import { createContext } from "react";

export type SidebarController = {
    lockSidebarPersistent: () => void;
    unlockSidebarPersistent: () => void;
    lockSidebar: () => void;
    unlockSidebar: () => void;
    resetSidebar: () => void;
};

export const SidebarControllerContext = createContext<SidebarController>(null as unknown as SidebarController);
